import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .typeBadge {
    width: 28px;
    height: 18px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 3px;
    padding: 1px 2px;
    line-height: 1;
    letter-spacing: 0;
    text-align: end;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    background: var(--background);
    color: var(--text-color-secondary);
    flex-shrink: 0;
    z-index: 1;
  }

  .absolute {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 18px;
    height: 14px;
    font-size: 7px;
  }

  .css {
    background: rebeccapurple;
    color: white;
  }

  .js,
  .javascript {
    background: #f7df1e;
    color: #000;
  }
`;

export function TypeBadge({ language, normalizeType, position = 'inline' }) {
  const type = normalizeType(language);
  return <span className={[styles.typeBadge, position === 'absolute' ? styles.absolute : '', styles[type]].join(' ')}>{type}</span>;
}
